import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable, of } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';

import { SweepOption, SweepOptionYield } from './sweep-option';

@Injectable({
  providedIn: 'root'
})
export class SweepOptionsService {
  private defaultApiUrl = '/api/secure/securities/v1/securities?securitycategory=SWEEPOPTION';

  private sweepOptionObservable: Observable<SweepOption[]>;

  constructor(
    private http: HttpClient
  ) {}

  /**
   * Sweeop Option by sweeop option symbol
   * @param symbol sweeop option symbol
   * @returns sweep option
   */
  getSweepOptionBySymbol(symbol: string): Observable<SweepOption> {
      return this.getSweepOptions().pipe(
        map((sweepOptions: SweepOption[]) => {
          return this.prepareSweepOption(this.filterSweepOptionsByCode(symbol, sweepOptions ? sweepOptions : []), symbol);
        })
      );
  }

  /**
   * Sweeop Options
   * @returns List of sweep option
   */
  getSweepOptions(): Observable<SweepOption[]> {
    if (this.sweepOptionObservable) {
      return this.sweepOptionObservable;
    }

    this.sweepOptionObservable = this.http.get(this.defaultApiUrl).pipe(
      catchError((error: any) => {
        return of(null);
      }),
      shareReplay(1)
    );

    return this.sweepOptionObservable;
  }

  private filterSweepOptionsByCode(symbol: string, sweepOptions: any[]): SweepOption {
    const foundOptions = sweepOptions.filter((sweepOption: any) => {
      return sweepOption && sweepOption.symbol === symbol;
    });

    if (foundOptions && foundOptions.length > 0) {
      return foundOptions[0];
    }

    return null;
  }

  private prepareSweepOption(rawSweepOption: SweepOption, symbol: string): SweepOption {
    if (!rawSweepOption || !rawSweepOption.yield || rawSweepOption.yield.length === 0) {
      return null;
    }

    const yields = this.getYieldsBySymbol(rawSweepOption.yield, symbol);

    if (!yields) {
      return null;
    }

    return {
      symbol: rawSweepOption.symbol,
      title: rawSweepOption.title,
      description: rawSweepOption.description,
      yield: yields
    };
  }

  private getYieldsBySymbol(rawYields: any[], symbol: string): SweepOptionYield[] {
    const yields = rawYields.filter((rawYield: any) => {
      if (!rawYield) {
        return false;
      }

      if (rawYield.preferred) {
        return true;
      }

     return (
              (symbol === 'FDUXX' || symbol === 'PMZXX') &&
              ((rawYield.duration === '365' || rawYield.duration === '7') && rawYield.unit === 'day')
            );
    }).map((rawYield: any) => {
      return {
        value: rawYield.value,
        duration: rawYield.duration,
        durationUnit: rawYield.unit,
        asOfDate: rawYield.asOfDate
      };
    });

    if (yields && yields.length > 0) {
      return yields;
    }

    return null;
  }
}
